<template>
	<div :class="{errored: field.isErrored() && field.getTouched(), disabled: field.options.disabled}">
		<label class="fieldLabel" @click="field.setTouched()">{{ field.label }}</label>
		<div class="radioContainer">
			<div v-for="(val, label) in field.options.choices" :key="val">
				<input type="radio" v-if="field.options.disabled" :name="field.getQualifiedName()" disabled :value="val" v-model="model" :tabindex="tabindex">
				<input type="radio" v-else :name="field.getQualifiedName()" :value="val" v-model="model" @change="field.setValue(model)" :tabindex="tabindex">
				<label @click="labelClick(val, $event)" v-html="label"></label>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'BlFormFieldRadio',
	inject: ['blFormLiveUpdateFields'],
	props: ['field', 'tabindex'],
	watch: {
		'field.options.choices'() {
			if(this.model && !Object.values(this.field.options.choices).includes(this.model)) {
				this.model = null
				this.field.setValue(this.model)
			}
		}
	},
	data() {
		return {
			model: this.field.value
		}
	},
	methods: {
		focusInput(event) {
			if(event.composedPath()[0].tagName == 'LABEL') event.composedPath()[0].parentElement.querySelector('input').focus()
		},
		labelClick(val, event) {
			if(this.field.options.disabled) return
			this.focusInput(event)
			this.model = val
			this.field.setValue(this.model)
		}
	},
	created() {
		let req = {}
		if(!this.field.options.choices) {
			req[this.field.name] = {loadAll: true}
			this.blFormLiveUpdateFields(req)
		}
	},
	mounted() {
		this.field.emitter.focus.subscribe(() => this.$el.querySelector('input[type="radio"]').focus())
		this.field.emitter.change.subscribe(() => this.model = this.field.value)
	}
}
</script>

<style scoped lang="scss">
.radioContainer {
	display: flex;
}

.radioContainer > div {
	display: flex;
}

.fieldLabel {
	color: var(--bl-legend);
	font-size: 12px;
	padding-left: 4px;
}

.radioContainer label {
	margin-left: 10px;
	margin-right: 8px;
	display: inline-block;
	height: 24px;
	line-height: 24px;
	cursor: pointer;
	user-select: none;
}

input {
	display: inline-block;
	outline: none;
	position: relative;
}

input:active:before, input:focus:before {
	content: ' ';
	width: 14px;
	height: 14px;
	margin-left: 4px;
	margin-top: 1px;
	display: block;
	position: absolute;
	box-shadow: 0 0 0 10px var(--bl-primary);
	opacity: .2;
	border-radius: 50%;
	animation: active-animate-in .1s both;
	cursor: pointer;
}

input:after {
	cursor: pointer;
	margin-top: -5px;
	width: 22px;
	transition: color .2s;
	height: 22px;
	font-size: 22px;
	background-color: var(--bl-surface);
	display: block;
	font-family: Material icons;
}

input:not(:checked):after {
	content: 'radio_button_unchecked';
	color: var(--bl-legend);
}

input:checked:after {
	content: 'radio_button_checked';
	color: var(--bl-primary);
}

@keyframes active-animate-in {
	0% {
		transform: scale(0);
		opacity: 0;
	}

	100% {
		transform: scale(1);
		opacity: 0.2;
	}
}

.errored > label {
	color: var(--bl-error);
}

div.disabled {
	label {
		color: var(--bl-legend);
		cursor: default;
	}

	input:after {
		cursor: default;
	}

	input:checked:after {
		color: var(--bl-legend);
	}

	input:active:before, input:focus:before {
		box-shadow: none;
	}
}
</style>